/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
export type MemoModalMemoFragment = { id: string, content: string, createdAt: TimeString };

export const MemoModalMemoFragmentDoc = gql`
    fragment MemoModalMemo on ChatRoomMemo {
  id
  content
  createdAt
}
    `;